import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import {Observable} from 'rxjs/Rx';
import { forgetPassword } from 'src/app/models/User';
import { APIConstants } from 'src/app/app.constants';
@Injectable({
  providedIn: 'root'
})
export class ForgetPasswordService {

  constructor(private httpClient : HttpClient) { }
  readonly url = APIConstants.BASE_URL

    forgetPassword(user: forgetPassword): Observable<any>{
      let headers = new HttpHeaders({
        'Content-type': 'application/json',
      });
      let options = { headers: headers }; 
    
      return this.httpClient.put(this.url+'/user/update-password',user,options);

    }
}
